import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {sizing} from "@khanacademy/wonder-blocks-tokens";

/**
 * Renders pagination controls for the table view of guide transcripts.
 * It includes buttons to navigate to the beginning of conversations and
 * to the next page of results.
 *
 * Note: This is used instead of the build-in pagination because SimpleTable
 * does not yet support server-side pagination, it only supports client-side
 * pagination.
 */
export function TableViewPagination({
    cursor,
    cursorResult,
    pathname,
}: {
    cursor: string | null | undefined;
    cursorResult: string | null | undefined;
    pathname: string;
}) {
    if (!cursor && !cursorResult) {
        return null;
    }
    return (
        <View style={styles.pagination}>
            <Button href={pathname} kind="tertiary" disabled={!cursor}>
                {t`Beginning of conversations`}
            </Button>
            <span>|</span>
            <Button
                href={`?cursor=${cursorResult}`}
                kind="tertiary"
                disabled={!cursorResult}
            >
                {t`Next page`}
            </Button>
        </View>
    );
}

const styles = StyleSheet.create({
    pagination: {
        flexDirection: "row",
        alignItems: "center",
        gap: sizing.size_080,
        alignSelf: "center",
        marginBlockStart: sizing.size_160,
    },
});
